import { client } from "./utils";
import { formatAppListResponse } from "./utils/helpers";

export const getDocHeadersList = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_LIST_DOC_V3",
    data: {
      module: params.module,
      departmentId: params.departmentId ? params.departmentId : undefined,
      pageNumber: params.pageNumber,
      top: params.top || 100,
      filter: params.filter
    },
  };
  
  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const getDocHeaderById = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_LIST_DOC_V3",
    data: {
      module: params.module,
      operationCode: params.operationCode,
      lineType: params.lineType,
    }
  };
  
  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const getDocDetails = (params: { [name: string]: any }) => {
   const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_LIST_DET_V3",
    data: {
      module: params.module,
      operationCode: params.operationCode,
      departmentId: params.departmentId ? params.departmentId : undefined,
      pageNumber: params.pageNumber,
      top: params.top || 100,
      filter: params.filter,
      lineType: params.lineType,      
      rowNumber: params.rowNumber,    
      appId: params.appId,      
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IUpdateDocDetails {
  clientDbId: number;
  locale: string;
  module: string;
  operationType: string;
  operationCode: string;
  barcode: string;
  quantityApp: number;
  lot: string;
  locationPaletteFrom?: string;
  locationPaletteTo?: string;
  objectCode: string;
  ignoreWarnings?: number;
  note?: string;
  rowNumber?: number;
  extraInfo1?: string;
  extraInfo2?: string;
  extraInfo3?: string;
  extraInfo4?: string;
  extraInfo5?: string;
  departmentId?: string;
}

export const updateDocDetails = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_EDIT_D_V3",
    data: {
      module: params.module,
      operationType: params.operationType,
      operationCode: params.operationCode,
      mscanCode: params.barcode,
      quantityApp: params.quantityApp,
      kodas_0l1: params.locationPaletteFrom,
      kodas_0l2: params.locationPaletteTo,
      lot: params.lot,
      objectCode: params.objectCode,
      lot2: params.lot2,
      objectCode2: params.objectCode2,
      expDate: params.expDate,
      expDate2: params.expDate2,
      ignoreWarnings: params.ignoreWarnings ? params.ignoreWarnings : 0,
      note: params.note,
      rowNumber: params.rowNumber,
      extraInfo1: params.extraInfo1,
      extraInfo2: params.extraInfo2,
      extraInfo3: params.extraInfo3,
      extraInfo4: params.extraInfo4,
      extraInfo5: params.extraInfo5,
      scannedWithCamera: params.scannedWithCamera ? 1 : 0,
      departmentId: params.departmentId ? params.departmentId : undefined,
      id: params.id,
      warningId: params.warningId ? params.warningId : undefined,
      ...(params.locationPaletteFrom && { kodas_0l1: params.locationPaletteFrom }),
      ...(params.locationPaletteTo && { kodas_0l2: params.locationPaletteTo })
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IManageIsFullyColected {
  clientDbId: number;
  locale: string;
  module: string;
  operationType: string;
  operationCode: string;
  rowNumber: number;
  isFullyCollected: number;
  lot: string;
  objectCode: string;
  productCode: string;
  unitCode: string;
  barcode: string;
}

export const manageIsFullyCollected = (params: IManageIsFullyColected) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_MANAGE_IS_FULLY_COLLECTED",
    data: {
      module: params.module,
      operationType: params.operationType,
      operationCode: params.operationCode,
      rowNumber: params.rowNumber,
      isFullyCollected: params.isFullyCollected,
      lot: params.lot,
      objectCode: params.objectCode,
      productCode: params.productCode,
      barcode: params.barcode,
      unitCode: params.unitCode,
      version: "V3"
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IDeleteRow {
  clientDbId: number;
  module: string;
  operationType: string;
  operationCode: string;
  rowNumber: number;
  id: string | number;
  locale: string;
}

export const deleteRecord = (params: IDeleteRow) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_DELETE_REC",
    data: {
      module: params.module,
      operationType: params.operationType,
      operationCode: params.operationCode,
      rowNumber: params.rowNumber,
      id: params.id,
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IUserModuleResponse {
  modulis: string;
  arRodyti: string | number;  
  arAktyvus: string | number; 
  klaida: string;
  eil_nr: string | number;    
}

export interface IUserModule {
  module: string;
  show: boolean;
  disabled: boolean;
  errorMessage: string;
  order: number;
}

export const getUserModules = (params: {
  clientDbId: number;
  user: string;
  locale: string;
}): Promise<IUserModule[]> => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_USER_MODULES",
    data: {
      user: params.user,
      locale: params.locale,
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then((res) => {
      const rawModules: IUserModuleResponse[] = res?.data?.app || [];

      return rawModules.map((mod) => ({
        module: mod.modulis,
        show: mod.arRodyti === 1 || mod.arRodyti === "1",
        disabled: mod.arAktyvus === 0 || mod.arAktyvus === "0",
        errorMessage: mod.klaida || "",
        order: parseInt(String(mod.eil_nr), 10) || 0,
      }));
    });
};

export const manageFiles = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_FILE",
    data: {
      module: params.module,
      operationCode: params.operationCode,
      rowNumber: params.rowNumber,
      oper: params.oper,          // 'L', 'S', 'D', 'I'
      fileCode: params.fileCode,  // reikalingas 'S' ir 'D'
      file: params.file,          // reikalingas 'I'
      fileType: params.fileType,  // reikalingas 'I'
      description: params.description,
      version: "V3",
    },
  };

  return client
  .post("/client/application", query, {
    headers: {
      "accept-language": params.locale,
    },
  })
  .then((res) => {
    if (params.oper === "D" || params.oper === "I") {
      return { success: true };
    }
    return formatAppListResponse(res);
  })
  .catch((err) => {
    if ((params.oper === "D" || params.oper === "I") && err.response?.data?.errorMessage?.includes("did not return a result set")) {
      return { success: true };
    }
    console.error("manageFiles error:", err.response?.data || err.message);
    throw err;
  });
}